module.exports = __webpack_public_path__ + "img/hongbao_bottom.300eb4c1.png";